// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file monitoreo_sesion.proto (package sextante.monitoreo.sesion.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file monitoreo_sesion.proto.
 */
export const file_monitoreo_sesion: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Con que valores se evaluo un organismo en un lote. Es la copia CONGELADA al momento del
 * calculo, no la configuracion vigente: si el cliente sube un umbral en octubre, los informes
 * de agosto tienen que seguir diciendo lo mismo.
 * 
 * Los cuatro umbrales van `optional` porque ausente significa "sin referencia" -se muestra, no
 * alerta-. Un `double` no-opcional en cero se leeria como "umbral cero", que es lo contrario:
 * alertaria con la primera deteccion.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoReferencia
 */
export type MonitoreoReferencia = Message<"sextante.monitoreo.sesion.v1.MonitoreoReferencia"> & {
  /**
   * Como se mide: individuos por arbol, acaros por lupada, % de arboles, presencia critica.
   *
   * @generated from field: string unidad = 1;
   */
  unidad: string;

  /**
   * Cualquier deteccion es alerta, sin gradiente. Ignora los umbrales.
   *
   * @generated from field: bool es_critico = 2;
   */
  esCritico: boolean;

  /**
   * Grupo del organismo. BENEFICO nunca alerta.
   *
   * @generated from field: optional string grupo_id = 3;
   */
  grupoId?: string | undefined;

  /**
   * @generated from field: optional double nivel_bajo_max = 4;
   */
  nivelBajoMax?: number | undefined;

  /**
   * @generated from field: optional double nivel_medio_max = 5;
   */
  nivelMedioMax?: number | undefined;

  /**
   * % de arboles
   *
   * @generated from field: optional double incidencia_bajo_max = 6;
   */
  incidenciaBajoMax?: number | undefined;

  /**
   * % de arboles
   *
   * @generated from field: optional double incidencia_medio_max = 7;
   */
  incidenciaMedioMax?: number | undefined;

  /**
   * De que ajuste del cliente salieron estos valores. 0 = nunca se ajusto, son los por defecto
   * del cultivo.
   *
   * @generated from field: int32 referencia_version = 8;
   */
  referenciaVersion: number;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoReferencia.
 * Use `create(MonitoreoReferenciaSchema)` to create a new message.
 */
export const MonitoreoReferenciaSchema: GenMessage<MonitoreoReferencia> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 0);

/**
 * Detalle de una sesion de monitoreo.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleItem
 */
export type MonitoreoSesionDetalleItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleItem"> & {
  /**
   * @generated from field: string finca_nombre = 1;
   */
  fincaNombre: string;

  /**
   * Semana del anio de la sesion.
   *
   * @generated from field: int32 semana = 2;
   */
  semana: number;

  /**
   * yyyy-MM-dd
   *
   * @generated from field: string fecha = 3;
   */
  fecha: string;

  /**
   * Tipo de monitoreo de la sesion.
   *
   * @generated from field: string tipo = 4;
   */
  tipo: string;

  /**
   * Nombre del monitor que hizo la captura.
   *
   * @generated from field: optional string monitor = 5;
   */
  monitor?: string | undefined;

  /**
   * Nombre del agronomo responsable.
   *
   * @generated from field: optional string agronomo = 6;
   */
  agronomo?: string | undefined;

  /**
   * true si el monitor cerro la sesion.
   *
   * @generated from field: bool is_finalizada = 7;
   */
  isFinalizada: boolean;

  /**
   * @generated from field: repeated sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleLoteItem lotes = 8;
   */
  lotes: MonitoreoSesionDetalleLoteItem[];

  /**
   * Recorrido de la sesion: un punto por arbol muestreado, PLANO (no anidado
   * por lote) y en el orden de captura - el monitor camina de un lote a otro
   * sin pausas, es un solo camino continuo, igual que lo modela
   * SessionDao.getRecorrido() del lado movil. Ordenar por fecha_captura al
   * consumirlo.
   *
   * @generated from field: repeated sextante.monitoreo.sesion.v1.MonitoreoSesionArbolPuntoItem puntos = 9;
   */
  puntos: MonitoreoSesionArbolPuntoItem[];

  /**
   * Arboles muestreados que NO tienen coordenada, y por eso no estan en
   * `puntos`. El GPS es puntual al guardar y puede fallar sin bloquear la
   * captura, asi que el recorrido puede tener menos puntos que la muestra del
   * lote. Se cuenta aparte para que la web lo diga ("3 arboles sin ubicacion")
   * en vez de dejar al agronomo creyendo que faltan datos.
   *
   * @generated from field: int32 arboles_sin_ubicacion = 10;
   */
  arbolesSinUbicacion: number;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleItem.
 * Use `create(MonitoreoSesionDetalleItemSchema)` to create a new message.
 */
export const MonitoreoSesionDetalleItemSchema: GenMessage<MonitoreoSesionDetalleItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 1);

/**
 * Un arbol muestreado dentro del recorrido. detalles va SIN promediar - a
 * diferencia de MonitoreoSesionDetalleLoteItem.inc, que es el promedio del
 * LOTE entero - porque esto es la lectura de UN solo arbol; el cliente reusa
 * la misma logica de semaforo (getPeorPlagaLote/getEstado, semaforo.ts) que
 * ya usa para lotes, sin duplicar la regla del lado servidor.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionArbolPuntoItem
 */
export type MonitoreoSesionArbolPuntoItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionArbolPuntoItem"> & {
  /**
   * @generated from field: int32 numero_arbol = 1;
   */
  numeroArbol: number;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;

  /**
   * ISO 8601, para ordenar el recorrido
   *
   * @generated from field: string fecha_captura = 4;
   */
  fechaCaptura: string;

  /**
   * plagaEnfermedadId -> cantidad cruda
   *
   * @generated from field: map<string, double> detalles = 5;
   */
  detalles: { [key: string]: number };

  /**
   * Id real del lote (calza con ClienteFincaLoteResponse.id /
   * MonitoreoSesionDetalleLoteItem.id). El web lo usa para agrupar el
   * recorrido por lote -un mapa por tarjeta de lote, no uno global de toda
   * la finca-.
   *
   * @generated from field: string lote_id = 6;
   */
  loteId: string;

  /**
   * Tamano de fruta de ESE arbol, para el tooltip del mapa (especificacion v1.0, 6.1). Ausente
   * en los arboles anteriores a que se capturara, y en los que el monitor no lo registro.
   *
   * @generated from field: optional string tamano_fruta = 7;
   */
  tamanoFruta?: string | undefined;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionArbolPuntoItem.
 * Use `create(MonitoreoSesionArbolPuntoItemSchema)` to create a new message.
 */
export const MonitoreoSesionArbolPuntoItemSchema: GenMessage<MonitoreoSesionArbolPuntoItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 2);

/**
 * Lote monitoreado en la sesion.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleLoteItem
 */
export type MonitoreoSesionDetalleLoteItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleLoteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: double area_ha = 3;
   */
  areaHa: number;

  /**
   * Arboles del lote.
   *
   * @generated from field: int32 total_arboles = 4;
   */
  totalArboles: number;

  /**
   * Arboles revisados en la sesion.
   *
   * @generated from field: int32 muestra = 5;
   */
  muestra: number;

  /**
   * Estado fenologico del cultivo que registro el monitor.
   *
   * @generated from field: optional string fenologia = 6;
   */
  fenologia?: string | undefined;

  /**
   * @generated from field: optional string observaciones = 7;
   */
  observaciones?: string | undefined;

  /**
   * plagaEnfermedadId -> promedio por arbol
   *
   * @generated from field: map<string, double> inc = 8;
   */
  inc: { [key: string]: number };

  /**
   * Cuantos arboles muestreados hay en cada estado fenologico. El reporte la
   * dibuja como barra apilada; `fenologia` (un solo valor) se queda para quien
   * solo quiera una etiqueta, pero NO describe al lote cuando sus arboles estan
   * en estados distintos -que es lo normal-.
   *
   * @generated from field: repeated sextante.monitoreo.sesion.v1.MonitoreoSesionFenologiaItem fenologia_distribucion = 9;
   */
  fenologiaDistribucion: MonitoreoSesionFenologiaItem[];

  /**
   * Cuantos arboles de la muestra tenian la plaga (conteo > 0). Es la otra mitad
   * de `inc`: con el promedio solo no se puede decir si 6 acaros por arbol son 6
   * en todos o 240 en uno. La incidencia -el % de arboles afectados- sale de
   * afectados / muestra, y es la metrica con la que el informe de Campoalegre
   * compara contra el umbral.
   *
   * plagaEnfermedadId -> arboles con presencia
   *
   * @generated from field: map<string, int32> afectados = 10;
   */
  afectados: { [key: string]: number };

  /**
   * Igual que en el dashboard: con que valores se evaluo cada organismo. Vacio en las sesiones
   * anteriores al congelado.
   *
   * @generated from field: map<string, sextante.monitoreo.sesion.v1.MonitoreoReferencia> referencias = 11;
   */
  referencias: { [key: string]: MonitoreoReferencia };

  /**
   * Cultivo del lote (especificacion v1.0, 6.1). El nombre va para el encabezado del informe.
   *
   * @generated from field: optional string cultivo_id = 12;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: optional string cultivo_nombre = 13;
   */
  cultivoNombre?: string | undefined;

  /**
   * Cuantos arboles de la muestra hay en cada tamano de fruta, en el orden del catalogo
   * (F1, F2, F3). Los arboles que no registraron tamano NO cuentan: la suma puede ser menor
   * que `muestra`, y eso es informacion -dice cuantos quedaron sin medir-, no un error.
   *
   * @generated from field: repeated sextante.monitoreo.sesion.v1.MonitoreoSesionTamanoFrutaItem tamano_fruta_distribucion = 14;
   */
  tamanoFrutaDistribucion: MonitoreoSesionTamanoFrutaItem[];

  /**
   * Lo que contesto el monitor al cerrar el lote. Ausente = no se pregunto -sesiones anteriores
   * a la pantalla de cierre, o una App sin actualizar-, que NO es lo mismo que haber contestado
   * que no: el informe no muestra el indicador en ese caso, en vez de afirmar que el monitor
   * dijo que no hacia falta aplicar.
   *
   * @generated from field: optional bool aplicar = 15;
   */
  aplicar?: boolean | undefined;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionDetalleLoteItem.
 * Use `create(MonitoreoSesionDetalleLoteItemSchema)` to create a new message.
 */
export const MonitoreoSesionDetalleLoteItemSchema: GenMessage<MonitoreoSesionDetalleLoteItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 3);

/**
 * Un tramo de la distribucion de tamanos de un lote.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionTamanoFrutaItem
 */
export type MonitoreoSesionTamanoFrutaItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionTamanoFrutaItem"> & {
  /**
   * codigo del catalogo: "F1", "F2", "F3"
   *
   * @generated from field: string tamano = 1;
   */
  tamano: string;

  /**
   * @generated from field: int32 arboles = 2;
   */
  arboles: number;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionTamanoFrutaItem.
 * Use `create(MonitoreoSesionTamanoFrutaItemSchema)` to create a new message.
 */
export const MonitoreoSesionTamanoFrutaItemSchema: GenMessage<MonitoreoSesionTamanoFrutaItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 4);

/**
 * Un estado fenologico dentro de un lote, con cuantos arboles estan en el.
 * Va el CONTEO y no el porcentaje: el porcentaje lo calcula quien dibuja, sobre
 * la suma de la distribucion, para que las partes de la barra y su leyenda
 * salgan del mismo numero y siempre sumen 100.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionFenologiaItem
 */
export type MonitoreoSesionFenologiaItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionFenologiaItem"> & {
  /**
   * descripcion del catalogo: "Floracion", "Estado Vegetativo"...
   *
   * @generated from field: string estado = 1;
   */
  estado: string;

  /**
   * @generated from field: int32 arboles = 2;
   */
  arboles: number;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionFenologiaItem.
 * Use `create(MonitoreoSesionFenologiaItemSchema)` to create a new message.
 */
export const MonitoreoSesionFenologiaItemSchema: GenMessage<MonitoreoSesionFenologiaItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 5);

/**
 * Sesion de la que se pide el detalle.
 *
 * @generated from message sextante.monitoreo.sesion.v1.GetMonitoreoSesionDetalleRequest
 */
export type GetMonitoreoSesionDetalleRequest = Message<"sextante.monitoreo.sesion.v1.GetMonitoreoSesionDetalleRequest"> & {
  /**
   * @generated from field: string sesion_id = 1;
   */
  sesionId: string;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.GetMonitoreoSesionDetalleRequest.
 * Use `create(GetMonitoreoSesionDetalleRequestSchema)` to create a new message.
 */
export const GetMonitoreoSesionDetalleRequestSchema: GenMessage<GetMonitoreoSesionDetalleRequest> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 6);

/**
 * Lotes y sesiones que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardResponse
 */
export type MonitoreoSesionDashboardResponse = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardResponse"> & {
  /**
   * @generated from field: repeated sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardLoteItem lotes = 1;
   */
  lotes: MonitoreoSesionDashboardLoteItem[];

  /**
   * @generated from field: repeated sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardSesionItem sesiones = 2;
   */
  sesiones: MonitoreoSesionDashboardSesionItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 3;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardResponse.
 * Use `create(MonitoreoSesionDashboardResponseSchema)` to create a new message.
 */
export const MonitoreoSesionDashboardResponseSchema: GenMessage<MonitoreoSesionDashboardResponse> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 7);

/**
 * Lote de la finca que aparece en el historico.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardLoteItem
 */
export type MonitoreoSesionDashboardLoteItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardLoteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardLoteItem.
 * Use `create(MonitoreoSesionDashboardLoteItemSchema)` to create a new message.
 */
export const MonitoreoSesionDashboardLoteItemSchema: GenMessage<MonitoreoSesionDashboardLoteItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 8);

/**
 * `datos` es un mapa de mapas (loteId -> plagaId -> incidencia) en REST; proto3 no permite un mapa
 * como valor de otro mapa directo, de ahi el wrapper `MonitoreoSesionIncidenciaPorPlaga`. La
 * AUSENCIA de una key de lote en `datos` sigue significando "no se monitoreo esa semana" (vs.
 * presente con mapa vacio = "se monitoreo, sin detecciones") — el cliente ya encapsula esa semantica
 * en `leerIncidencia()`, sin tocar.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardSesionItem
 */
export type MonitoreoSesionDashboardSesionItem = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardSesionItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Semana del anio de la sesion.
   *
   * @generated from field: int32 semana = 2;
   */
  semana: number;

  /**
   * yyyy-MM-dd
   *
   * @generated from field: string fecha = 3;
   */
  fecha: string;

  /**
   * true si el monitor cerro la sesion.
   *
   * @generated from field: bool is_finalizada = 4;
   */
  isFinalizada: boolean;

  /**
   * @generated from field: map<string, sextante.monitoreo.sesion.v1.MonitoreoSesionIncidenciaPorPlaga> datos = 5;
   */
  datos: { [key: string]: MonitoreoSesionIncidenciaPorPlaga };

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 6;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 7;
   */
  ultimaActualizacion: bigint;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionDashboardSesionItem.
 * Use `create(MonitoreoSesionDashboardSesionItemSchema)` to create a new message.
 */
export const MonitoreoSesionDashboardSesionItemSchema: GenMessage<MonitoreoSesionDashboardSesionItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 9);

/**
 * Incidencia de cada plaga en un lote.
 *
 * @generated from message sextante.monitoreo.sesion.v1.MonitoreoSesionIncidenciaPorPlaga
 */
export type MonitoreoSesionIncidenciaPorPlaga = Message<"sextante.monitoreo.sesion.v1.MonitoreoSesionIncidenciaPorPlaga"> & {
  /**
   * plagaEnfermedadId -> promedio por arbol
   *
   * @generated from field: map<string, double> valores = 1;
   */
  valores: { [key: string]: number };

  /**
   * Arboles de la muestra con la plaga presente (conteo > 0), y el tamano de la
   * muestra. Van juntos porque la incidencia es la division de los dos: mandar
   * solo `afectados` obligaria a buscar la muestra en otro lado -y el dashboard
   * no la traia-.
   *
   * plagaEnfermedadId -> arboles con presencia
   *
   * @generated from field: map<string, int32> afectados = 2;
   */
  afectados: { [key: string]: number };

  /**
   * arboles evaluados en el lote
   *
   * @generated from field: int32 muestra = 3;
   */
  muestra: number;

  /**
   * Con que valores se evaluo cada organismo, congelados en la sesion. Un lote SIN este mapa no
   * es un error: son las sesiones anteriores al congelado, y la web cae a los valores vigentes
   * del cultivo (especificacion 5.2, ultima fila). El relleno las va completando.
   *
   * @generated from field: map<string, sextante.monitoreo.sesion.v1.MonitoreoReferencia> referencias = 4;
   */
  referencias: { [key: string]: MonitoreoReferencia };

  /**
   * Cultivo del lote. Lo necesita la web para resolver los valores vigentes de la tabla por
   * cultivo cuando el lote NO trae referencias congeladas (sesiones anteriores al congelado):
   * sin el, solo queda caer a los umbrales del catalogo viejo, donde limon, naranja y
   * mandarina comparten la fila "Citricos" y por lo tanto el mismo umbral.
   *
   * @generated from field: optional string cultivo_id = 5;
   */
  cultivoId?: string | undefined;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.MonitoreoSesionIncidenciaPorPlaga.
 * Use `create(MonitoreoSesionIncidenciaPorPlagaSchema)` to create a new message.
 */
export const MonitoreoSesionIncidenciaPorPlagaSchema: GenMessage<MonitoreoSesionIncidenciaPorPlaga> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 10);

/**
 * Pedido del historico de una finca.
 *
 * @generated from message sextante.monitoreo.sesion.v1.GetMonitoreoSesionDashboardByFincaIdRequest
 */
export type GetMonitoreoSesionDashboardByFincaIdRequest = Message<"sextante.monitoreo.sesion.v1.GetMonitoreoSesionDashboardByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.GetMonitoreoSesionDashboardByFincaIdRequest.
 * Use `create(GetMonitoreoSesionDashboardByFincaIdRequestSchema)` to create a new message.
 */
export const GetMonitoreoSesionDashboardByFincaIdRequestSchema: GenMessage<GetMonitoreoSesionDashboardByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 11);

/**
 * Relleno de referencias congeladas de sesiones ya guardadas.
 * 
 * NO se llama "recalcular" como la seccion 6.1 de la especificacion, porque no recalcula: un lote que
 * ya tiene referencias no se toca, ni siquiera si el cliente cambio sus valores despues. El nombre
 * tiene que decir lo que hace -- el motivo de no repintar el historico esta en
 * MonitoreoRellenoReferenciasService.
 * 
 * Ninguna pantalla lo llama todavia, y eso tambien es a proposito: la seccion 8.3 propone un boton
 * "Recalcular monitoreos anteriores" en la configuracion, y un boton que repinta informes firmados es
 * justo lo que el congelado existe para evitar. Esto es la tarea de puesta en produccion (paso 7 de
 * 12.1), que se corre una vez por finca despues de cargar la libreria v4.
 *
 * @generated from message sextante.monitoreo.sesion.v1.RellenarMonitoreoReferenciasRequest
 */
export type RellenarMonitoreoReferenciasRequest = Message<"sextante.monitoreo.sesion.v1.RellenarMonitoreoReferenciasRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Sesiones a rellenar. Vacia = todas las de la finca, que es el caso de la puesta en produccion.
   *
   * @generated from field: repeated string sesion_ids = 2;
   */
  sesionIds: string[];
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.RellenarMonitoreoReferenciasRequest.
 * Use `create(RellenarMonitoreoReferenciasRequestSchema)` to create a new message.
 */
export const RellenarMonitoreoReferenciasRequestSchema: GenMessage<RellenarMonitoreoReferenciasRequest> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 12);

/**
 * Que hizo el relleno. Lo que no se pudo hacer viaja contado, no silenciado: con el catalogo a medio
 * cargar el relleno queda incompleto y hay que volver a correrlo, y desde afuera no hay otra forma de
 * saberlo.
 *
 * @generated from message sextante.monitoreo.sesion.v1.RellenarMonitoreoReferenciasResponse
 */
export type RellenarMonitoreoReferenciasResponse = Message<"sextante.monitoreo.sesion.v1.RellenarMonitoreoReferenciasResponse"> & {
  /**
   * Sesiones que ganaron referencias en al menos un lote.
   *
   * @generated from field: int32 sesiones_rellenadas = 1;
   */
  sesionesRellenadas: number;

  /**
   * Lotes que ganaron referencias.
   *
   * @generated from field: int32 lotes_rellenados = 2;
   */
  lotesRellenados: number;

  /**
   * Lotes que ya tenian y no se tocaron. En una segunda corrida son todos: asi se ve que es idempotente.
   *
   * @generated from field: int32 lotes_ya_tenian = 3;
   */
  lotesYaTenian: number;

  /**
   * Lotes sin cultivo asignado. No se pueden resolver; se arreglan en la configuracion de la finca.
   *
   * @generated from field: int32 lotes_sin_cultivo = 4;
   */
  lotesSinCultivo: number;

  /**
   * Organismos que quedaron sin referencia por no tener fila en la tabla por cultivo. Mayor a cero =
   * la libreria v4 no esta completa para los cultivos de esa finca.
   *
   * @generated from field: int32 organismos_sin_referencia = 5;
   */
  organismosSinReferencia: number;
};

/**
 * Describes the message sextante.monitoreo.sesion.v1.RellenarMonitoreoReferenciasResponse.
 * Use `create(RellenarMonitoreoReferenciasResponseSchema)` to create a new message.
 */
export const RellenarMonitoreoReferenciasResponseSchema: GenMessage<RellenarMonitoreoReferenciasResponse> = /*@__PURE__*/
  messageDesc(file_monitoreo_sesion, 13);

/**
 * Sesiones de monitoreo de plagas de la SPA Cliente, capturadas en campo con MonitoreoApp. Logica propia
 * del servicio gRPC, sin la capa vieja de servicios. El Cliente
 * (auditado en toda la app con un subagente) solo consume 2 de los 5 endpoints REST: el detalle
 * (para el reporte imprimible) y el dashboard historico (para el mapa/sidebar/analisis). El listado
 * crudo anidado (finca -> lotes -> arboles -> detalles, con geometria por arbol) NO tiene ningun
 * consumidor en este cliente web: la captura la hace la app movil, y el server ya pre-agrega todo en
 * "inc"/"datos" antes de que este cliente lo vea. Por eso NO se migra ListByFincaId/ListByClienteId/
 * List/Guardar de este dominio — quedan solo en REST, sin equivalente gRPC (si algun otro cliente,
 * como la app movil, llegara a necesitarlos, se agregan ahi, no ahora).
 * 
 * GetDetalle SIGUE SIN DELTA (pedido explicito, 2026-09-15): es un lookup puntual por sesionId, no
 * un listado -no tiene sentido un watermark para "una sola sesion"-. El cliente lo cachea 5 minutos
 * en memoria (ver SesionDetalleGrpcService.ts), no via este mecanismo.
 * 
 * GetDashboardByFincaId SI TIENE DELTA (2026-09-15, antes no): trae TODO el historico de la finca
 * que cambio desde ultima_sincronizacion, sin filtro de anio server-side -el cliente sincroniza una
 * sola vez y filtra el anio localmente, mismo criterio que el resto de los dominios con delta (ver
 * GrpcMonitoreoSesionDatabase.ts)-.
 * 
 * Nombres de mensaje con prefijo de dominio: ver terceros_lote.proto para el gotcha real del
 * csharp_namespace compartido — revisar que un nombre no exista ya en otro .proto antes de usarlo.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.monitoreo.sesion.v1.MonitoreoSesionService
 */
export const MonitoreoSesionService: GenService<{
  /**
   * Detalle de una sesion para el reporte imprimible: lotes, muestra e incidencia por plaga. Sin delta.
   * Sesion inexistente: NotFound.
   *
   * @generated from rpc sextante.monitoreo.sesion.v1.MonitoreoSesionService.GetDetalle
   */
  getDetalle: {
    methodKind: "unary";
    input: typeof GetMonitoreoSesionDetalleRequestSchema;
    output: typeof MonitoreoSesionDetalleItemSchema;
  },
  /**
   * Historico de sesiones de una finca para el mapa y los graficos, por delta.
   *
   * @generated from rpc sextante.monitoreo.sesion.v1.MonitoreoSesionService.GetDashboardByFincaId
   */
  getDashboardByFincaId: {
    methodKind: "unary";
    input: typeof GetMonitoreoSesionDashboardByFincaIdRequestSchema;
    output: typeof MonitoreoSesionDashboardResponseSchema;
  },
  /**
   * Le pone referencias congeladas a los lotes de sesiones que no las tienen. Idempotente.
   *
   * @generated from rpc sextante.monitoreo.sesion.v1.MonitoreoSesionService.RellenarReferencias
   */
  rellenarReferencias: {
    methodKind: "unary";
    input: typeof RellenarMonitoreoReferenciasRequestSchema;
    output: typeof RellenarMonitoreoReferenciasResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_monitoreo_sesion, 0);

